import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { TableRow } from "../../components/table-components/TableRow";
import { Partnership } from "../../service/api-response/PartnershipListSuccessResponse";

interface PartnershipListRowProps {
  partnership: Partnership;
  href: string;
}

export const PartnershipListRow = ({
  partnership,
  href,
}: PartnershipListRowProps) => {
  return (
    <TableRow>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {partnership.pool}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {partnership.memberCardTypeName}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};
